import { LayoutWrapper } from 'components/LayoutWrapper';
import { NotFoundView } from 'components/NotFoundView';
import React, { FC, useEffect } from 'react';
import { trackPage } from 'services/analytics';

const NotFound: FC = () => {
  useEffect(() => {
    trackPage('Not Found');
  }, []);
  return (
    <LayoutWrapper>
      <NotFoundView />
    </LayoutWrapper>
  );
};

export default NotFound;
